import React, {useContext, useState, useEffect} from 'react';
import "./teacherManagementForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    { id: 'name', label: 'Name', minWidth: 170 },
    {
        id: 'gender',
        label: 'Gender',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'phoneNo',
        label: 'Phone No.',
        minWidth: 170,
        align: 'right',
        // format: (value) => {return ("60" + value);} ,
    },
    {
        id: 'icNo',
        label: 'NRIC No.',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];

const TeacherManagementList = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { setFormData } = actions.formActions; // export setFormData function
    const { getAllTeachers, getSingleTeacherInfoByUuid } = actions.generalActions;
    const { teachers } = state.generalStates;

    useEffect(() => {
        getAllTeachers();
    }, []);

    const [teacherName, setTeacherName] = React.useState(null);

    const handleTeacherNameChange = (event) => {
        setTeacherName(event.target.value);
    };

    const onViewDetailClick = (uuid) => {
        setFormData({teacherRegistration : {
                uuid: uuid
            }});
        getSingleTeacherInfoByUuid(history, uuid);
    };

    const handleSearchButton = () => {
        getAllTeachers(teacherName);
    };

    return (
        <div className="student-management-container">
            <h1 className="header">Teacher Management</h1>
            <div className="paperContainer">
                <TextField className="text-field" label="Teacher name" onChange={handleTeacherNameChange}/>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>
            </div>
            <div className="table-container">
                {teachers && <FixedHeaderTable columns={columns} rows={teachers} buttonContent="View Details" buttonAction={onViewDetailClick}/>}
            </div>
        </div>
    )
}

export default withRouter(TeacherManagementList)
